var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparationModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.42187 9.81209C4.63839 9.81209 5.72158 10.9159 5.72158 12.2764C5.72158 13.6368 4.6371 14.7393 3.42188 14.7393",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.54297 14.7383L12.5021 14.7383C13.7237 14.7383 14.7133 13.6316 14.7133 12.2654C14.7133 10.8992 13.7288 9.81255 12.5085 9.81255L3.54297 9.81255",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.55752 14.7393C2.34101 14.7393 1.25781 13.6354 1.25781 12.275C1.25781 10.9145 2.34229 9.81209 3.55752 9.81209",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.56641 5.92578L12.5255 5.92578C13.7472 5.92578 14.7368 4.81907 14.7368 3.45288C14.7368 2.08669 13.7523 1.00005 12.5319 1.00005L3.56641 1.00005",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3008 5.92912C10.0843 5.92912 9.00107 4.82527 9.00107 3.46482C9.00107 2.10437 10.0856 1.00195 11.3008 1.00195",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.58096 5.92773C2.36445 5.92773 1.28125 4.82389 1.28125 3.46343C1.28125 2.10298 2.36573 1.00057 3.58096 1.00057",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparationModelIcon);
export default __webpack_public_path__ + "static/media/separation-model-icon.181da395b625b1e5ce2bf17c8c9bfff7.svg";
export { ForwardRef as ReactComponent };